import { render, staticRenderFns } from "./ToolRight.vue?vue&type=template&id=65ed07b6&"
import script from "./ToolRight.vue?vue&type=script&lang=js&"
export * from "./ToolRight.vue?vue&type=script&lang=js&"
import style0 from "./ToolRight.vue?vue&type=style&index=0&id=65ed07b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports